import type { ComponentPropsWithRef } from "react";

import { cn } from "~/utils";

export function Input({ className, ...props }: ComponentPropsWithRef<"input">) {
  return (
    <input
      className={cn(
        "min-h-12 rounded-md border border-transparent bg-field px-4 py-3 text-sm text-foreground outline-none transition-[border-color,box-shadow] placeholder:text-muted focus:border-brand focus:ring-2 focus:ring-brand/20 aria-invalid:border-danger aria-invalid:focus:ring-danger/20 disabled:cursor-not-allowed disabled:opacity-60",
        className,
      )}
      {...props}
    />
  );
}
